import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import IdealBodyWeightOutput from './../../components/IdealBodyWeightOutput/IdealBodyWeightOutput';
import fetchIdealBodyWeightAction from './../../store/actions/fetch/fetchIdealBodyWeightAction';
import Loader from './../../components/Loader/Loader'
import * as actionTypes from "../../store/actions/idealBodyWeightAction";

/**
 * Ideal Body Weight container
 */
class IdealBodyWeight extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  getText(){
    const {selectedBCS, data} = this.props;
    if(selectedBCS < 5){
      return (5 - selectedBCS)*10 + "% " + data.underweight;
    }
    else if(selectedBCS > 5){
      return (selectedBCS - 5)*10 + "% " + data.overweight;
    }
    else{
      return data.idealWeight;
    }
  }

  render() {
    const {error, pending, defaultValues, ready} = this.props;
    // If there is a need for default data
    if(!ready && !error && !pending) {
      defaultValues();
    }
    // If data is pending
    if(pending || !ready) return (
      <Loader/>
    );

    // Get text
    const label = this.getText();
    const {data, selectedBCS, species} = this.props;

    // Return switcher
    return (
      <div className='nppe2-fc-ideal-body-weight-output__wrapper'>
        {error && <span className='nppe2-fc-ideal-body-weight-output__error'>{error}</span>}
        {!error && <IdealBodyWeightOutput
          text={label}
          data={data}
          selectedBCS={selectedBCS}
          species={species}
        /> }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.idealBodyWeightReducer.error,
    data: state.idealBodyWeightReducer.data,
    pending: state.idealBodyWeightReducer.pending,
    ready: state.idealBodyWeightReducer.ready,
    selectedBCS: state.conditionScoreReducer.selected,
    species: state.breedReducer.selectedType,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchIdealBodyWeightAction
      },
      dispatch,
    ),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(IdealBodyWeight);
